import gql from 'graphql-tag';

export const GET_ALL_STATES = gql`
  query GetAllStates {
    GetAllStates {
      Id
      StateCode
      Name
      HUDClimateZone
    }
  }
`;
